import { SVGProps } from "react";

export function FailVerifiBadge({
    xmlns = "http://www.w3.org/2000/svg",
    ...props
}: SVGProps<SVGSVGElement>) {
    return (
        <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_23039_222721)">
                <path d="M15.9972 3.16602L13.8906 6.44408L7.89221 16.0727L7.49749 12.0344L7.18794 7.64438H0.989043L0.926758 7.9908C2.51804 7.9908 3.45945 8.7498 3.72134 10.3037L4.92578 20.5399L4.93328 20.5171L4.94942 20.6672H9.21146L16.8283 6.06308L18.4279 3.16602H15.9972Z" fill="#98A2B3" />
                <path d="M9.42889 12.101H9.70585L15.7269 3.16602L5.30273 5.84652V6.129L9.42889 7.63352V12.101Z" fill="#FD853A" />
            </g>
            <defs>
                <clipPath id="clip0_23039_222721">
                    <rect width="18" height="17.5012" fill="white" transform="translate(0.926758 3.16602)" />
                </clipPath>
            </defs>
        </svg>
    );
}
